export const InvitesActionType = Object.freeze({
  SET_INVITES: "Invites:: Set Invites data",
  SET_EDIT_INVITE: "Invites:: Set edit Invites",
  SET_ORDER_BY: "Invites:: Set Order by field",
  SET_PAGING_OPT: "Invites:: Set Pagination options",
  SET_FILTER: "Invites:: Set Filter",
  SET_SEARCH_TEXT: "Invites :: Set Search Text",
  SET_PAGE_OFFSET: "Invites :: Set Offset of the Invites query",
  SET_BREAK_DOWN: "Invites :: Set break down",
});

export const INVITE_PROP = Object.freeze({
  ID: "id",
  EMAIL: "email",
  ROLE: "role",
  EXPIRY_DATE: "expiry_date",
  STATUS: "status",
  SENT_DATE: "sent_date",
});

export const INVITE_COLUMNS_ENHANCED = Object.freeze([
  {
    id: INVITE_PROP.EMAIL,
    label: "Email",
    numeric: false,
    disablePadding: false,
  },
  {
    id: INVITE_PROP.ROLE,
    label: "Role",
    numeric: false,
    disablePadding: false,
  },
  {
    id: INVITE_PROP.STATUS,
    label: "Status",
    numeric: false,
    disablePadding: false,
  },
  {
    id: INVITE_PROP.SENT_DATE,
    label: "Sent On",
    numeric: false,
    disablePadding: false,
  },
  {
    id: INVITE_PROP.EXPIRY_DATE,
    label: "Expire On",
    numeric: false,
    disablePadding: false,
  },
]);
